import { useScreen } from '../../../../../../../hooks'
import { FormikField } from '../../../../../../Formik'
import { InputField } from '../../../../../../Input'

import { getRequestWizardCardStageInputValueProps } from './Input.utils'

import * as styles from './Input.module.css'

function Input({ card: { label, name, required }, fieldClassName }) {
  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        className: fieldClassName,
        label,
        required,
        shouldAdaptToMobileScreen: true,
      }}
      getValueProps={getRequestWizardCardStageInputValueProps}
      name={name}
      placeholder={label}
      wrapperClassName={styles.input}
    />
  )
}

export default Input
